<ng-container *ngIf="control && control.errors">
  <div *ngIf="control.invalid && (control.dirty || control.touched)" class="form-errorMsg">
    <i class="form-errorIcon" [ngClass]="{'form-errorIcon_required': control.errors.required,
    'form-errorIcon_warning': !control.errors.required}"></i>
    <div *ngIf="control.errors.required">
      {{ 'FORMS.ERROR.REQUIRED' | translate }}
    </div>
    <div *ngIf="control.errors.customerNumberConflict">
      {{ 'FORMS.ERROR.CUSTOMER_NUMBER_CONFLICT' | translate }}
    </div>
    <div *ngIf="control.errors.maxlength">
      {{ 'FORMS.ERROR.MAX_LENGTH' | translate:{length: control.errors.maxlength.requiredLength} }}
    </div>
    <div *ngIf="control.errors.min">
      {{ 'FORMS.ERROR.MIN' | translate:{value: control.errors.min.min} }}
    </div>
    <div *ngIf="control.errors.minShort">
      {{ 'FORMS.ERROR.MIN_SHORT' | translate:{value: control.errors.minShort.min} }}
    </div>
    <div *ngIf="control.errors.max">
      {{ 'FORMS.ERROR.MAX' | translate:{value: control.errors.max.max} }}
    </div>
    <div *ngIf="control.errors.maxShort">
      {{ 'FORMS.ERROR.MAX_SHORT' | translate:{value: control.errors.maxShort.max} }}
    </div>
    <div *ngIf="control.errors.positionNr">
      {{ 'FORMS.ERROR.POSITION_NR' | translate }}
    </div>
    <div *ngIf="control.errors.uniqueRequired">
      {{ (control.errors.uniqueRequired.message || 'FORMS.ERROR.UNIQUE_REQUIRED') | translate }}
    </div>
    <div *ngIf="control.errors.passwordMissmatch">
      {{ 'FORMS.ERROR.PASSWORD_MISSMATCH' | translate }}
    </div>
    <div *ngIf="control.errors.invalidZipCode">
      {{ 'FORMS.ERROR.ZIP' | translate }}
    </div>
    <div *ngIf="control.errors.invalidEmailList">
      {{ 'FORMS.ERROR.MAIL' | translate }}
    </div>
    <div *ngIf="control.errors.pattern" [ngSwitch]="control.errors.pattern.requiredPattern">
      <ng-container *ngSwitchCase="VALIDATORS.PATTERN.STREET_NR">
        {{ 'FORMS.ERROR.STREET_NR' | translate }}
      </ng-container>
      <ng-container *ngSwitchCase="VALIDATORS.PATTERN.MAIL">
        {{ 'FORMS.ERROR.MAIL' | translate }}
      </ng-container>
      <ng-container *ngSwitchCase="VALIDATORS.PATTERN.PHONE">
        {{ 'FORMS.ERROR.PHONE' | translate }}
      </ng-container>
      <ng-container *ngSwitchCase="VALIDATORS.PATTERN.FAX">
        {{ 'FORMS.ERROR.FAX' | translate }}
      </ng-container>
      <ng-container *ngSwitchCase="VALIDATORS.PATTERN.POSITION_NR">
        {{ 'FORMS.ERROR.POSITION_NR_INVALID' | translate }}
      </ng-container>
      <ng-container *ngSwitchCase="VALIDATORS.PATTERN.NO_BLANK_STRING">
        {{ 'FORMS.ERROR.BLANK_STRING' | translate }}
      </ng-container>
      <ng-container *ngSwitchCase="VALIDATORS.PATTERN.WEBSITE">
        {{ 'FORMS.ERROR.WEBSITE' | translate }}
      </ng-container>
    </div>
  </div>
</ng-container>
